"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _useUserQuery = _interopRequireDefault(require("./useUserQuery"));
const useUserRepository = function () {
  let forceRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  const query = (0, _useUserQuery.default)(forceRefresh);
  const findUser = (0, _react.useCallback)(function () {
    return query.refetch();
  }, [query]);
  return {
    findUser,
    isInitialLoadingUser: query.isInitialLoading,
    user: query.data
  };
};
var _default = exports.default = useUserRepository;